import React, { PureComponent, useEffect } from 'react';
import { Tab, Tabs } from '../components';

interface IProps {
  navigation: any;
  renderIcon: any;
  getLabelText: any;
  onTabPressOverride?: () => void;
}

export class NavigationTabs extends PureComponent<IProps, {}> {
  public render() {
    const { onTabPressOverride } = this.props;
    const navigation = this.props.navigation;
    const { routes, index } = this.props.navigation.state;

    return (
      <Tabs>
        {routes.map((route, idx) => {
          const active = index === idx;
          const icon = this.props.renderIcon({
            route,
            focused: active,
            index,
          });
          const title = this.props.getLabelText({
            route,
            focused: active,
            index,
          });
          return (
            <Tab
              icon={icon}
              active={active}
              currentTabIndex={idx}
              key={route.routeName}
              title={title}
              useDarkTheme={false}
              amountOfTabs={routes.length - 1}
              onPress={() => {
                if (onTabPressOverride !== undefined) {
                  onTabPressOverride(idx);
                }
                navigation.navigate(route.routeName);
              }}
            />
          );
        })}
      </Tabs>
    );
  }
}
